import './src/vaadin-board.js';
export * from './src/vaadin-board.js';
